export default () => {
    $(document).ready(function () {
        const isLoggedIn = document.cookie.includes('obp_logged_in=true');
        const headerLink = $('.button-account');

        var currentUrl = window.location.hostname;
        var envSuffix = currentUrl.includes('local') || currentUrl.includes('test') ||
            currentUrl.includes('dev') || currentUrl.includes('staging') ? 'staging.' : '';

        if (isLoggedIn) {
            const $loggedInButton = $('<div class="button button--login logged-in hidden-xs">My Account</div>');
            const $dropdownMenu = $('<div class="dropdown-menu"></div>');
            const $dropdownMenuInner = $('<div class="dropdown-menu__inner"></div>');

            $dropdownMenuInner.append(`<a href="https://${envSuffix}booking.landmarkspace.co.uk/account/bookings">Bookings</a>`);
            $dropdownMenuInner.append(`<a href="https://${envSuffix}booking.landmarkspace.co.uk/account">My account</a>`);
            $dropdownMenuInner.append(`<a href="https://${envSuffix}booking.landmarkspace.co.uk/">Search Locations</a>`);
            $dropdownMenuInner.append(`<a class="dropdown-menu__logout-button" href="#">Logout</a>`);

            $loggedInButton.append($dropdownMenu);
            $dropdownMenu.append($dropdownMenuInner);

            headerLink.html($loggedInButton);

            // Mobile links
            $('.logged-in--mobile').show();
            $('.login--mobile, .register--mobile').hide();

            // Update links for logged-in mobile links according to environment
            $('.logged-in--mobile a').each(function () {
                const href = $(this).attr('href');
                if (href !== '#') {
                    $(this).attr('href', `https://${envSuffix}${href.replace('https://', '')}`); // Update href with env suffix
                }
            });

            // Event listener for the logout button
            $('.dropdown-menu__logout-button').click(function (e) {
                e.preventDefault();
                // Change the cookie obp_logged_in to false and set a new cookie landmark_wordpress_logged_out to true,
                // so the OBP knows the user has logged out
                document.cookie = 'obp_logged_in=false; domain=.landmarkspace.co.uk;';
                document.cookie = 'landmark_wordpress_logged_out=true; domain=.landmarkspace.co.uk;';
                location.reload();
            });
        } else {
            headerLink.html(`<a href="https://${envSuffix}booking.landmarkspace.co.uk/login" class="button button--login hidden-xs">Login</a>`);

            // Mobile links
            $('.login--mobile, .register--mobile').show();
            $('.logged-in--mobile').hide();
            // Update links for login and register mobile links according to environment
            $('.login--mobile a, .register--mobile a').each(function () {
                const href = $(this).attr('href');
                if (href !== '#') {
                    $(this).attr('href', `https://${envSuffix}${href.replace('https://', '')}`); // Update href with env suffix
                }
            });
        }
    });
}